import React from 'react';
import './styles.css';
import { Button, Col, Row } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { BupSpinner, PageLayout, ErrorMessage } from '@BUP/components';
import { useBraveUpSurveysApi, useQuestionProApi, useAuth } from '@BUP/hooks';
import { useHistory } from 'react-router';

const DataSurveyPage = () => {
  const history = useHistory();
  const { isLoadingSurvey, survey, errorSurvey } = useBraveUpSurveysApi();
  const { isLoadingFolders, folders, errorFolders } = useQuestionProApi(survey);
  const { user } = useAuth();
  const { roles } = user;
  const { name: rolName } = roles;
  const { enrollmentId } = user;
  // Filtro de folders para encontrar la url correspondiente al rol de usuario
  const filterFolder = folders?.filter((folder) =>
    folder?.name?.toLowerCase().includes(rolName.toLowerCase())
  );
  const [surveyFiltered] = filterFolder;
  const urlSurvey = surveyFiltered?.url;
  const urlSurveyConcat = `${urlSurvey}?custom1=${enrollmentId}`;
  // console.log('URL', urlSurveyConcat);
  return (
    <PageLayout className="layout">
      <Row>
        <Col span={24} className="col-button" align="start">
          <Button
            type="text"
            className="button-back"
            onClick={() => history.push('/data')}
          >
            <ArrowLeftOutlined />
            Volver a DATA
          </Button>
        </Col>
      </Row>

      {isLoadingSurvey || isLoadingFolders ? (
        <BupSpinner size="large" />
      ) : errorSurvey || errorFolders ? (
        <ErrorMessage />
      ) : (
        <div className="embed-container">
          <iframe
            title="data-page__survey-iframe"
            className="embed-container_iframe"
            src={urlSurveyConcat}
            frameBorder="0"
            allowFullScreen
            embed
          />
        </div>
      )}
    </PageLayout>
  );
};
export default DataSurveyPage;
